// Add unified product
export const ADD_UNIFIED_PRODUCT = 'ADD_UNIFIED_PRODUCT';
export const ADD_UNIFIED_PRODUCT_STARTED = 'ADD_UNIFIED_PRODUCT_STARTED';
export const ADD_UNIFIED_PRODUCT_ENDED = 'ADD_UNIFIED_PRODUCT_ENDED';

// Get all unified products
export const GET_UNIFIED_PRODUCTS = 'GET_UNIFIED_PRODUCTS';
export const GET_UNIFIED_PRODUCTS_STARTED = 'GET_UNIFIED_PRODUCTS_STARTED';
export const GET_UNIFIED_PRODUCTS_ENDED = 'GET_UNIFIED_PRODUCTS_ENDED';

// Get single unified product
export const GET_UNIFIED_PRODUCT_BY_ID = 'GET_UNIFIED_PRODUCT_BY_ID';
export const GET_UNIFIED_PRODUCT_BY_ID_STARTED = 'GET_UNIFIED_PRODUCT_BY_ID_STARTED';
export const GET_UNIFIED_PRODUCT_BY_ID_ENDED = 'GET_UNIFIED_PRODUCT_BY_ID_ENDED';

// Edit unified product
export const EDIT_UNIFIED_PRODUCT = 'EDIT_UNIFIED_PRODUCT';
export const EDIT_UNIFIED_PRODUCT_STARTED = 'EDIT_UNIFIED_PRODUCT_STARTED';
export const EDIT_UNIFIED_PRODUCT_ENDED = 'EDIT_UNIFIED_PRODUCT_ENDED';

// Delete unified product
export const DELETE_UNIFIED_PRODUCT = 'DELETE_UNIFIED_PRODUCT';
